import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	editAssociationErrorTitle: {
		id: 'business-fields.common.fixit-error-flag.edit-association-error-title',
		defaultMessage:
			'<normal><strong>{fieldName}</strong> is not associated to the <strong>{issueType}</strong> issue type</normal>',
		description:
			'Error message saying the user cannot edit the data because the field is not associated to the issue type',
	},
	updateFieldAssociationAction: {
		id: 'business-fields.common.fixit-error-flag.update-field-association-action',
		defaultMessage: 'Update field association',
		description: 'Link text on the flag to update the field association',
	},
	editPermissionErrorTitle: {
		id: 'business-fields.common.fixit-error-flag.edit-permission-error-title',
		defaultMessage: 'You do not have permission to edit in this project',
		description: 'Error message raised when user has no edit permission in this project',
	},
	editPermissionErrorAction: {
		id: 'business-fields.common.fixit-error-flag.edit-permission-error-action',
		defaultMessage: 'Contact your project admin',
		description: 'Text on the button that tells user to contact the project admin',
	},
	editIssueTypesPermissionErrorAction: {
		id: 'business-fields.common.fixit-error-flag.edit-issue-types-permission-error-action',
		defaultMessage: 'Contact your project admin to edit issue types',
		description:
			"Text on the button that tells user to contact the project admin to edit the project's issue types",
	},
	editAssociationErrorTitleIssueTermRefresh: {
		id: 'business-fields.common.fixit-error-flag.edit-association-error-title-issue-term-refresh',
		defaultMessage:
			"<normal><strong>{fieldName}</strong> isn't associated with a <strong>{issueType}</strong>.</normal>",
		description:
			'Error message saying the user cannot edit the data because the field is not associated to the issue type',
	},
	editIssueTypesPermissionErrorActionIssueTermRefresh: {
		id: 'business-fields.common.fixit-error-flag.edit-issue-types-permission-error-action-issue-term-refresh',
		defaultMessage: 'Contact your project admin to edit work types',
		description:
			"Text on the button that tells user to contact the project admin to edit the project's issue types",
	},
});
